export default __webpack_public_path__ + "static/Deathworm_Horn-5c878b596885c3511fb0bc31e8246fc0.png";